/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RecordManualPaymentRequest } from '../models/RecordManualPaymentRequest';
import type { RegistrationReportSummary } from '../models/RegistrationReportSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RegistrationService {

    /**
     * API to get registration report with filters and pagination
     * @param type Filter by registration type (Rider, Team, Coach, Associate)
     * @param fromDate Filter by start date
     * @param toDate Filter by end date
     * @param searchName Search by name (partial match, case-insensitive)
     * @param pageNumber Page number for pagination (default: 1)
     * @param pageSize Page size for pagination (default: 10)
     * @returns RegistrationReportSummary Success
     * @throws ApiError
     */
    public static registrationGetRegistrationReport(
        type?: string,
        fromDate?: string,
        toDate?: string,
        searchName?: string,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<RegistrationReportSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/registration/report',
            query: {
                'type': type,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchName': searchName,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to export registration report to Excel
     * @param type Filter by registration type (Rider, Team, Coach, Associate)
     * @param fromDate Filter by start date
     * @param toDate Filter by end date
     * @param searchName Search by name (partial match, case-insensitive)
     * @returns string Success
     * @throws ApiError
     */
    public static registrationExportRegistrationReport(
        type?: string,
        fromDate?: string,
        toDate?: string,
        searchName?: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/registration/report/export',
            query: {
                'type': type,
                'fromDate': fromDate,
                'toDate': toDate,
                'searchName': searchName,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to record manual payment for a registration
     * @param requestBody Manual payment request
     * @returns string Success
     * @throws ApiError
     */
    public static registrationRecordManualPayment(
        requestBody?: RecordManualPaymentRequest,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/registration/record-payment',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

}
